import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { PolicyService } from '../policy.service';
import { ConstantsService } from "../constants.service";
import { SessionService } from "../session.service";

@Directive({
  selector: '[appCheckPolicyElse]'
})
export class CheckPolicyElseDirective {
  @Input() set appCheckPolicyElse (policies: string[]) {
    this.applyPermissions(policies.filter(policy => policy && policy.trim()));
  }

  constructor(
    private constantsService: ConstantsService,
    private sessionService: SessionService,
    private policyService: PolicyService,
    private viewContainer: ViewContainerRef,
    private templateRef: TemplateRef<any>
  ) {}

  private applyPermissions(policies: string[]) {
    this.viewContainer.clear();
    if (!policies || !Array.isArray(policies) || policies.length === 0) {
      return;
    }

    policies = policies.map(policyId => {
      return this.policyService.isPolicyId(policyId) ? policyId : this.policyService.getPolicyId(policyId);
    });

    this.constantsService.onReady(() => {
      const ids = this.sessionService.getValue('policy_ids');
      const safeIds: string[] = Array.isArray(ids) ? ids : [];

      if (!this.isAllowed(policies, safeIds)) {
        this.viewContainer.createEmbeddedView(this.templateRef);
      }
    })
  }

  private isAllowed = (policies: string[], ids: string[]) => {
    return policies.every(policy => ids.includes(policy));
  }
}
